import { render } from "./MailingBlockSpacer.vue?vue&type=template&id=c0c2d440"
import script from "./MailingBlockSpacer.vue?vue&type=script&lang=js"
export * from "./MailingBlockSpacer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__